var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data_svgrepo.com"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System / Data"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58 35V54.1667C58 60.5182 47.7025 65.6667 35 65.6667C22.2974 65.6667 12 60.5182 12 54.1667V35M58 35V15.8334M58 35C58 41.3515 47.7025 46.5 35 46.5C22.2974 46.5 12 41.3515 12 35M12 35V15.8334M58 15.8334C58 9.48212 47.7025 4.33337 35 4.33337C22.2974 4.33337 12 9.48212 12 15.8334M58 15.8334C58 22.1846 47.7025 27.3334 35 27.3334C22.2974 27.3334 12 22.1846 12 15.8334",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.f9b44797e09e81e989ca8b6ff10774fb.svg";
export { ForwardRef as ReactComponent };